<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <form @submit.prevent="bill">
        <!-- begin invoice -->
        <div class="invoice">
          <!-- begin invoice-header -->
          <div class="invoice-header">
            <div class="invoice-from">
              <small>{{ $t('restaurantSale.orderInfo') }}</small>
              <address class="m-t-5 m-b-5">
                <strong class="text-inverse">{{ $t('restaurantSale.order') }}: #{{
                  tableSelected.order_no
                }}</strong><br />
                {{ $t('restaurantSale.status') }}:
                {{ tableSelected.invoice_status }}<br />
                <!-- UI REFACTOR: Hide exchange rate display (KHR removed from UI) -->
                <!-- Backend still calculates with KHR for data consistency -->
              </address>
            </div>
            <div class="invoice-to">
              <small>{{ $t('restaurantSale.tableInfo') }}</small>
              <address class="m-t-5 m-b-5">
                <strong class="text-inverse">{{ $t('restaurantSale.table') }}:
                  {{ tableSelected.table_no }}</strong><br />
                {{ $t('restaurantSale.status') }}: {{ tableSelected.status_name
                }}<br />
                {{ $t('restaurantSale.numberOfCustomer') }}:
                {{ tableSelected.num_customer_status }}<br />
              </address>
            </div>
            <div class="invoice-date">
              <small>{{ $t('restaurantSale.dateAndTime') }}</small>
              <div class="date text-inverse m-t-5">
                {{ currentDate }}
              </div>
              <div class="invoice-detail">
                {{ $t('restaurantSale.startTime') }}:
                {{ tableSelected.start_time }} <br />
                {{ $t('restaurantSale.now') }}: {{ time }}
              </div>
            </div>
          </div>
          <!-- end invoice-header -->
          <!-- begin invoice-content -->
          <div class="invoice-content">
            <!-- begin invoice-price -->
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="invoice-price-row" style="width: 100%">
                  <div class="sub-price" style="width: 25%;margin-top: -8px;">
                    <small>{{ $t('restaurantSale.subtotal') }}</small>
                    <span class="text-inverse">{{ defaultCrrency }}
                      {{ model.sub_total | format_number }}</span>
                  </div>
                  <div class="sub-price" style="width: 25%;margin-top: -8px;">
                    <small>{{ $t('restaurantSale.preChargeAmount') }}</small>
                    <span class="text-inverse">{{ defaultCrrency }}
                      {{
                        tableSelected.total_pre_charge_amount | format_number
                      }}</span>
                  </div>
                  <div class="sub-price text-center" style="width: 170px">
                    <small>{{ $t('restaurantSale.discount') }}</small>
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <input type="radio" v-model="model.discount_type" id="dolar" :value="'$'" />
                        &nbsp;$
                      </b-input-group-prepend>
                      <b-form-input v-model.number="model.discount_rate" class="text-center form-control"
                        @input="calculate" ref="discount_rate" @focus="
                          () => [
                            (ref_input_last_focus = 'discount_rate'),
                            (value_keyboard_input = model.discount_rate)
                          ]
                        "></b-form-input>
                      <b-input-group-prepend is-text for="percentage">
                        <input type="radio" v-model="model.discount_type" id="percentage" :value="'%'" />
                        &nbsp;%
                      </b-input-group-prepend>
                    </b-input-group>
                  </div>
                  <div class="sub-price text-right" style="width: 25%; margin-top: -8px;">
                    <small>{{ $t('restaurantSale.vat') }}
                      {{ vatRate ? '(' + vatRate + '%)' : '' }}</small>
                    <span class="text-inverse">
                      {{ defaultCrrency }}
                      {{ model.vat_amount | format_number }}</span>
                  </div>
                </div>
              </div>
              <div class="invoice-price-right" style="background: #808B96;">
                <small>{{ $t('restaurantSale.total') }}</small>
                <span class="f-w-600">{{ defaultCrrency }}
                  {{ model.grand_total | format_number }}</span>
              </div>
            </div>
            <br />
            <div class="payment">
              <div class="row">
                <div class="col-md-3">
                  <div id="keyboard">
                    <!-- @onKeyPress="onKeyPress" -->
                    <ts-simple-keyboard @onChange="onChangeKeyBoard" :input="value_keyboard_input" :theme="theme" />
                  </div>
                  <!-- Bank info -->
                  <div v-if="tableSelected.member_card" class="mt-2 d-flex flex-column align-items-center">
                    <MemberCard :table="tableSelected.member_card" />
                  </div>
                  <!-- Bank info -->
                  <!-- <div class="mt-2 d-flex flex-column align-items-center">
                    <img v-show="selectedBankLogo" class="ts-rounded ts-h-20 ts-w-20" v-lazy="{
                      src: selectedBankLogo,
                      error: require('@/assets/logo.png'),
                      loading: require('@/assets/Rolling-1s-200px.svg'),
                      preLoad: 1.3,
                      attempt: 1
                    }" />
                    <div class="text-center">
                      <span>{{ model.bank_name }}</span>
                      <h6 v-if="model.account_name" class="text-center ts-font-bold mt-2 mb-0 text-uppercase text-info">
                        Name: {{ model.account_name }}
                      </h6>
                      <h6 v-if="model.account_number"
                        class="text-center ts-font-bold mt-2 mb-0 text-uppercase text-info">
                        Account #: {{ model.account_number }}
                      </h6>
                    </div>
                  </div> -->
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="col-form-label">
                        &diams; {{ $t('restaurantSale.cashPayment') }}</label>
                    </div>
                    <div class="col-md-6">
                      <label class="col-form-label">
                        &diams; {{ $t('restaurantSale.cashBack') }}</label>
                    </div>
                  </div>
                  <!-- UI REFACTOR: Single currency input (USD only shown on UI) -->
                  <!-- Backend still processes dual-currency (USD + KHR) for data integrity -->
                  <div class="invoice-price">
                    <div class="invoice-price-left">
                      <div class="form__group field">
                        <input ref="paid_in_default_currency" type="number" class="form__field"
                          :placeholder="$t('restaurantSale.cashPayment') + ' USD'" v-model="paid_in_default_currency"
                          min="0" @input="handleCashInput" @click="switchToCash" @focus="() => [
                            (ref_input_last_focus = 'paid_in_default_currency'),
                            (value_keyboard_input = paid_in_default_currency)
                          ]" />
                        <label for="name" class="form__label">
                          {{ $t('restaurantSale.cashIn') }} USD</label>
                      </div>
                    </div>
                    <div class="invoice-button">
                      <a @click.prevent="pickupAmountDefulatCurrency" class="btn btn-default">
                        <i class="fas fa-arrow-left fa-3x ts-pt-8"></i>
                      </a>
                    </div>
                    <div class="invoice-price-right">
                      <span class="f-w-600 text-success" :class="{
                        'text-danger': change_in_default_currency < 0
                      }">USD {{ change_in_default_currency | format_number }}</span>
                    </div>
                  </div>
                  <!-- UI REFACTOR: KHR input REMOVED from interface -->
                  <!-- KHR calculations still happen in backend via model.paid_in_riel -->
                  <div class="form-group row">
                    <!-- UI REFACTOR: Single payment method enforcement (Cash OR Bank, not both) -->
                    <label class="col-md-2 col-form-label">&diams; {{ $t('restaurantSale.otherPayment') }}</label>
                    <div class="col-md-5">
                      <ul class="list-inline payment-type">
                        <li :class="{ active: isActive == 'bank_transfer' }">
                          <a v-tooltip="$t('martSale.bankTransfer')" @click="selectBankPayment">
                            <i class="fa fa-university"></i>
                          </a>
                        </li>
                        <!-- UI REFACTOR: Coupon allowed with Cash only (not with Bank) -->
                        <li :class="{ active: model.paid_in_coupon > 0 }">
                          <a v-tooltip="$t('restaurantSale.coupon')" :class="{ 'text-muted': isBankPaymentActive }"
                            @click="selectCoupon">
                            <i class="fab fa-contao"></i>
                          </a>
                        </li>
                        <!-- UI REFACTOR: Removed Credit Card and Cheque options -->
                      </ul>
                      <small v-if="isCashPaymentActive" class="text-info d-block mt-2">
                        <i class="fas fa-info-circle"></i> Cash payment active (coupon available, click bank to switch)
                      </small>
                      <small v-if="isBankPaymentActive" class="text-info d-block mt-2">
                        <i class="fas fa-info-circle"></i> Bank payment active (coupon not available, enter cash to
                        switch)
                      </small>
                    </div>
                    <div class="col-md-5 mt-1" style="margin-left: -4px;">
                      <!-- <div class="option-row">
                        <textarea rows="2" class="form-control" :value="remarks"
                          @input="$emit('update-remarks', $event.target.value)"
                          :placeholder="$t('restaurantSale.remarks')"></textarea>
                      </div> -->
                      <div class="option-row">
                        <label class="col-form-label" style="padding-bottom: 0px;">
                          {{ $t('restaurantSale.remarks') }}
                        </label>
                        <a-select v-model="model.remarks" :options="remarksOptions" allowClear show-search
                          :show-arrow="false" option-filter-prop="children" class="ts-w-full"
                          :class="{ 'is-invalid': errors.has('serial_no') }" placeholder="Remarks"
                          @search="handleSearchRemarks"></a-select>
                      </div>
                      <a-alert class="ts-mt-1" v-if="
                        errors.has('change_in_usd') ||
                        errors.has('change_in_riel')
                      " message="Payment" :description="errors.first('change_in_usd')
                        ? errors.first('change_in_usd')
                        : errors.first('change_in_riel')
                        " type="error" show-icon closable />
                    </div>
                  </div>
                  <!-- UI REFACTOR: Bank selection only shown for bank_transfer -->
                  <div class="form-group row" v-if="isActive == 'bank_transfer'">
                    <label class="col-md-2 col-form-label">&diams; Bank Transfer</label>
                    <div class="col-md-10">
                      <ul class="ts-grid ts-grid-cols-11 ts-gap-11">
                        <li v-if="!model.bank_name" v-for="(record, index) in bankNameOptions" :key="index">
                          <a v-tooltip="record.label" @click="
                              ;[(model.bank_name = record.label)]
                          bankNameChange()
                            ">
                            <img class="ts-rounded ts-h-12 ts-w-12" v-lazy="{
                              src: record.bank_logo,
                              error: require('@/assets/logo.png'),
                              loading: require('@/assets/Rolling-1s-200px.svg'),
                              preLoad: 1.3,
                              attempt: 1
                            }" />
                          </a>
                        </li>
                      </ul>
                      <ul class="list-inline">
                        <li v-if="model.bank_name" v-for="(record, index) in accountOptions" :key="index">
                          <a :title="$t('martSale.bankTransfer')" @click="
                              ;[(model.account_number = record.value)]
                          accountChange()
                            " :class="{
                              active: model.account_number == record.value
                            }" class="btn btn-outline-info btn-sm">
                            <span>
                              {{ model.bank_name }}<br />
                              {{ record.name }}<br />
                              {{ record.label }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-group row">
                    <a-alert v-if="errors.has('account_number')" message="Payment"
                      :description="errors.first('account_number')" type="error" show-icon closable />
                    <div class="col-md-12">
                      <!-- bank_transfer -->
                      <!-- UI REFACTOR: Bank transfer in USD only (KHR input removed) -->
                      <!-- Backend model.bank_transfer_riel still exists for data consistency -->
                      <div class="invoice-price" v-if="isActive == 'bank_transfer'">
                        <div class="invoice-price-left">
                          <div class="form__group field">
                            <input type="number" class="form__field" placeholder="Bank Transfer in USD" min="0"
                              v-model.number="model.bank_transfer" @input="calculate" required ref="bank_transfer_usd"
                              @focus="() => [
                                (ref_input_last_focus = 'bank_transfer'),
                                (value_keyboard_input = model.bank_transfer)
                              ]" />
                            <label for="name" class="form__label">
                              Bank Transfer in USD
                            </label>
                          </div>
                          <a-alert v-if="errors.has('bank_transfer')" message="Payment"
                            :description="errors.first('bank_transfer')" type="error" show-icon closable />
                        </div>
                      </div>

                      <!-- UI REFACTOR: Removed Cheque and Credit Card payment sections -->

                      <!-- coupon - Automatically shown when cash is active -->
                      <div class="invoice-price" v-if="!isBankPaymentActive">
                        <div class="invoice-price-left">
                          <div class="form__group field">
                            <input type="number" class="form__field" :placeholder="$t('martSale.couponInUsd')" min="0"
                              v-model.number="model.paid_in_coupon" @input="calculate" ref="paid_in_coupon" @focus="() => [
                                (ref_input_last_focus = 'paid_in_coupon'),
                                (value_keyboard_input = model.paid_in_coupon)
                              ]" />
                            <label for="name" class="form__label">
                              {{ $t('martSale.couponInUsd') }}
                            </label>
                          </div>
                          <a-alert v-if="errors.has('paid_in_coupon')" message="Payment"
                            :description="errors.first('paid_in_coupon')" type="error" show-icon closable />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end invoice-content -->
        </div>
        <!-- end invoice -->
        <!-- begin invoice-footer -->
        <div class="invoice-footer">
          <div class="row">
            <div class="col-lg-3">
              <div style="padding-left:20px">
                <ts-checkbox v-model="model.is_city_ledger">{{
                  $t('restaurantSale.cityLedger')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.is_customer_ledger">{{
                  $t('restaurantSale.customerLedger')
                }}</ts-checkbox>
                <ts-checkbox v-model="model.is_clear_table">{{
                  $t('restaurantSale.isCleanFromTable')
                }}</ts-checkbox>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="btn-row pull-right">
                <ts-button class="btn btn-default" :disabled="waiting" @click.prevent="$emit('close')">
                  {{ $t('cancel') }}</ts-button>
                <ts-button type="submit" @click.prevent="bill" :waiting="waiting" class="btn btn-success btn-lg"><i
                    v-if="!waiting" class="fas fa-check fa-fw fa-lg"></i>
                  {{ $t('restaurantSale.bill') }}</ts-button>
              </div>
            </div>
          </div>
        </div>
        <!-- end invoice-footer -->
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Swal from 'sweetalert2'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import MemberCard from './MemberCheckOutTableCard.vue'

export default {
  name: 'checkBill',
  components: {
    MemberCard
  },
  data() {
    return {
      ref_input_last_focus: 'paid_in_default_currency',
      value_keyboard_input: null,
      theme: 'hg-theme-default hg-layout-numeric numeric-theme',
      show_bank: false,
      model: {
        stock_out_id: null,
        table_id: null,
        counter_id: null,
        paid_in_riel: null,
        paid_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        change_in_riel: null,
        change_in_usd: null,
        sub_total: null,
        discount_type: '%',
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_amount: null,
        grand_total: null,
        is_clear_table: true,
        is_city_ledger: false,
        is_customer_ledger: false,
        products: [],
        payment_method_id: 1,
        bank_name: null,
        account_number: null,
        account_name: null,
        bank_transfer: null,
        paid_by_cheque: null,
        bank_transfer_riel: null,
        total_pre_charge_amount: null,
        remarks: null,
      },
      paid_in_default_currency: null,
      // UI REFACTOR: paid_in_to_currency kept for backend compatibility but not shown in UI
      paid_in_to_currency: null,
      change_in_default_currency: 0,
      // UI REFACTOR: change_in_to_currency kept for backend but hidden from UI
      change_in_to_currency: 0,
      time: '00:00',
      waiting: false,
      isActive: '', // '' = cash payment, 'bank_transfer' = bank payment
      paymentMethods: [],
      errors: new Errors(),
      bankProfiles: [],
      remarksOptions: []
    }
  },
  created() {
    this.handleStartTime()
    this.setDataOnSelectedTable()
    this.model.counter_id = parseInt(localStorage.getItem('counterId'))
    this.fetchResource()
  },
  mounted() {
    this.$refs.paid_in_default_currency.focus()
    this.$refs.paid_in_default_currency.select()
  },
  filters: {
    format_number(value) {
      return `${parseFloat(value).toLocaleString()}`
    }
  },
  computed: {
    isShow: vm => arrayValue => {
      return _.includes(arrayValue, vm.model.payment_method_id)
    },
    notDisableFor: vm => arrayValue => {
      return !_.includes(arrayValue, vm.model.payment_method_id)
    },
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    currentDate() {
      return moment().format('dddd, MMMM Do')
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      // UI REFACTOR: Always return 'USD' for UI display
      // Backend still uses system setting for calculations
      return 'USD'
    },
    toCurrency() {
      // UI REFACTOR: Kept for backend compatibility, not displayed in UI
      if (this.$store.state.restaurantSale.customerOrder.systemSettings.default_currency == 'KHR') {
        return 'USD'
      }
      return 'KHR'
    },
    // UI REFACTOR: New computed properties for single payment method enforcement
    isCashPaymentActive() {
      return this.paid_in_default_currency > 0 && this.isActive !== 'bank_transfer'
    },
    isBankPaymentActive() {
      return this.isActive === 'bank_transfer'
    },
    paymentMethodOptions() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(pm => ({
          value: pm.payment_method_id,
          label: pm.payment_method
        }))
      }
      return []
    },
    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name,
        bank_logo: el.bank_logo
      }))
    },
    accountOptions() {
      let acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.account_number,
          name: el.account_name
        }))
      }
      return []
    },
    titleName() {
      switch (this.isActive) {
        case 'coupon':
          return 'Coupon'
        case 'credit_card':
          return 'Credit Card'
        case 'bank_transfer':
          return 'Bank Transfer'
        case 'paid_by_cheque':
          return 'Cheque'
      }
    },
    selectedBankLogo() {
      return this.bankProfiles
        .filter(b => b.bank_name == this.model.bank_name)
        .reduce((init, value) => (init = value.bank_logo), null)
    }
  },
  methods: {
    ...mapActions('restaurantSale/counterCheckout', [
      'bankProfile',
      'remarks',
      'paymentMethod'
    ]),
    handleSearchRemarks: debounce(async function (value) {
      if (!this.remarksOptions.find(el => el.value == value || el.label == value) && value) {
        this.remarksOptions.push({
          value: value,
          label: value,
        })
      }
    }, 500),
    // UI REFACTOR: New method to handle cash input and enforce single payment method
    handleCashInput() {
      // If user enters cash, clear bank payment and focus cash input
      if (this.paid_in_default_currency > 0 && this.isActive === 'bank_transfer') {
        this.isActive = ''
        this.model.payment_method_id = 1 // Set to cash payment method
        this.clearBankPayment()
        this.$nextTick(() => {
          if (this.$refs.paid_in_default_currency) {
            this.$refs.paid_in_default_currency.focus()
            this.$refs.paid_in_default_currency.select()
          }
        })
      }
      this.calculate()
    },
    // UI REFACTOR: New method to select bank payment and enforce single payment method
    selectBankPayment() {
      // Automatically clear cash and coupon when switching to bank
      if (this.isCashPaymentActive) {
        this.paid_in_default_currency = null
        this.paid_in_to_currency = 0
      }
      // Clear coupon as it's not allowed with bank
      this.model.paid_in_coupon = null

      this.isActive = 'bank_transfer'
      this.model.payment_method_id = 3
      this.onPaymentMethodChange()
    },
    // UI REFACTOR: New method to switch to cash payment when cash input is clicked
    switchToCash() {
      // If bank is active, clear it and switch to cash
      if (this.isBankPaymentActive) {
        this.isActive = ''
        this.model.payment_method_id = 1 // Set to cash payment method
        this.paid_in_default_currency = parseFloat(
          this.tableSelected.invoice_amount -
          this.tableSelected.total_pre_charge_amount
        )
        this.clearBankPayment()
        this.$nextTick(() => {
          if (this.$refs.paid_in_default_currency) {
            this.$refs.paid_in_default_currency.focus()
            this.$refs.paid_in_default_currency.select()
          }
        })
      }
    },
    // UI REFACTOR: New method to focus coupon input (auto-shown with cash)
    selectCoupon() {
      // If bank is active, do nothing (coupon field is hidden)
      if (this.isBankPaymentActive) {
        return
      }

      // Focus coupon input (always visible when cash mode)
      this.$nextTick(() => {
        if (this.$refs.paid_in_coupon) {
          this.$refs.paid_in_coupon.focus()
          this.$refs.paid_in_coupon.select()
        }
      })
    },
    // UI REFACTOR: New method to clear bank payment details
    clearBankPayment() {
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = null
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },
    setDataOnSelectedTable() {
      if (!_.isEmpty(this.tableSelected)) {
        this.model.stock_out_id = this.tableSelected.stock_out_id
        this.model.table_id = this.tableSelected.table_id
        this.paid_in_default_currency = parseFloat(
          this.tableSelected.invoice_amount -
          this.tableSelected.total_pre_charge_amount
        )
      }
      this.calculate()
    },
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    bill() {
      if (this.waiting) return

      // UI REFACTOR: Validate payment methods (Cash OR Bank, Coupon allowed with Cash only)
      const hasCashPayment = this.paid_in_default_currency > 0
      const hasBankPayment = this.model.bank_transfer > 0
      const hasCouponPayment = this.model.paid_in_coupon > 0

      // Cannot mix Cash and Bank
      if (hasCashPayment && hasBankPayment) {
        this.$notification['error']({
          message: 'Payment Validation',
          description: 'Please use only ONE payment method: Cash OR Bank Transfer',
          placement: 'bottomRight'
        })
        return
      }

      // Cannot use Coupon with Bank
      if (hasCouponPayment && hasBankPayment) {
        this.$notification['error']({
          message: 'Payment Validation',
          description: 'Coupon can only be used with Cash payment, not Bank Transfer',
          placement: 'bottomRight'
        })
        return
      }

      // Must have at least one payment method
      // if (!hasCashPayment && !hasBankPayment && !hasCouponPayment) {
      //   this.$notification['error']({
      //     message: 'Payment Required',
      //     description: 'Please enter a payment amount',
      //     placement: 'bottomRight'
      //   })
      //   return
      // } 

      // UI REFACTOR: Validate bank account selection if bank payment
      if (hasBankPayment && !this.model.account_number) {
        this.$notification['error']({
          message: 'Bank Account Required',
          description: 'Please select a bank account for bank transfer',
          placement: 'bottomRight'
        })
        return
      }

      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/store',
          Object.assign({}, this.model, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'check-bill'
          })
        )
        .then(response => {
          if (response.message_id == 1) {
            this.$emit('close')
            // UI REFACTOR: Success message shows USD only (KHR removed)
            Swal.fire({
              title: 'CHECK BILL',
              icon: 'success',
              html:
                response.message +
                '<br /><b>' +
                (response.next_locker_message ? (response.next_locker_message + '<br />') : '') +
                this.$t('restaurantSale.cashBack') +
                ': <span class="text-success">USD ' +
                parseFloat(this.change_in_default_currency).toLocaleString() +
                '</span></b>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false
            })
          }
          if (response.message_id == 50021 || response.message_id == 50022) {
            this.fetchTableByInterval()
            this.$notification['error']({
              message: 'Submit Bill',
              description: response.message,
              placement: 'bottomRight'
            })
          }
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$notification['error']({
            message: 'Submit Bill',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.waiting = false
        })
    },
    productPhoto(item) {
      if (item.photo === null) return ''

      return `/api/files?filePath=${item.photo}`
    },
    handleCheckTime: function (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    handleStartTime: function () {
      var today = new Date()
      var h = today.getHours()
      var m = today.getMinutes()
      var a
      m = this.handleCheckTime(m)
      a = h > 11 ? ' PM' : ' AM'
      h = h > 12 ? h - 12 : h

      this.time = h + ':' + m + a
      setTimeout(() => {
        this.handleStartTime()
      }, 500)
    },
    calculate() {
      // UI REFACTOR: Simplified calculation - UI uses USD only
      // Backend still receives both USD and KHR data for database consistency
      const actualDefaultCurrency = this.$store.state.restaurantSale.customerOrder.systemSettings.default_currency
      const isUSD = actualDefaultCurrency === 'USD'
      const ex = this.exchangeRate

      // Safe rounding helper
      const round2 = val => Number(Number(val || 0).toFixed(2))

      // Always round raw inputs before using
      this.paid_in_default_currency = round2(this.paid_in_default_currency)
      // UI REFACTOR: Set to 0 since KHR input is hidden
      this.paid_in_to_currency = 0
      this.model.discount_rate = round2(this.model.discount_rate)
      this.model.bank_transfer = round2(this.model.bank_transfer)
      // UI REFACTOR: bank_transfer_riel set to 0 (KHR input removed)
      this.model.bank_transfer_riel = 0

      // UI REFACTOR: Coupon allowed with cash, credit card and cheque removed
      this.model.paid_in_coupon = round2(this.model.paid_in_coupon)
      this.model.paid_in_credit_card = 0
      this.model.paid_by_cheque = 0

      let paid_in_default_currency = round2(this.paid_in_default_currency)
      let bank_transfer = round2(this.model.bank_transfer)
      let paid_in_coupon = round2(this.model.paid_in_coupon)
      let discount_rate = round2(this.model.discount_rate)

      // Subtotal
      this.model.sub_total = round2(
        parseFloat(this.tableSelected.sub_total) -
        parseFloat(this.tableSelected.total_pre_charge_amount)
      )

      // Discount calculation
      this.model.discount_amount =
        this.model.discount_type === '$'
          ? discount_rate
          : round2((this.model.sub_total * discount_rate) / 100)

      // Totals
      this.model.total_after_discount = round2(
        this.model.sub_total - this.model.discount_amount
      )
      this.model.vat_amount = round2(
        (this.model.total_after_discount * this.vatRate) / 100
      )
      this.model.grand_total = round2(
        this.model.total_after_discount + this.model.vat_amount
      )

      // Change calculation (includes cash + bank + coupon)
      this.change_in_default_currency = round2(
        paid_in_default_currency +
        bank_transfer +
        paid_in_coupon -
        this.model.grand_total
      )

      // UI REFACTOR: change_in_to_currency kept for backend but calculated for KHR
      this.change_in_to_currency = round2(
        isUSD
          ? this.change_in_default_currency * ex
          : this.change_in_default_currency / ex
      )

      // Backend model values (for database consistency)
      // UI REFACTOR: Always treat as USD payment on UI, but backend gets proper currency
      this.model.paid_in_usd = round2(
        paid_in_default_currency +
        parseFloat(this.tableSelected.total_pre_charge_amount)
      )
      this.model.paid_in_riel = 0
      this.model.change_in_usd = round2(this.change_in_default_currency)
      this.model.change_in_riel = round2(this.change_in_to_currency)

      // Pre-charge amount
      this.model.total_pre_charge_amount = parseFloat(
        this.tableSelected.total_pre_charge_amount
      )

      // Keep last input focus value (rounded!)
      this.value_keyboard_input = round2(
        this.ref_input_last_focus === 'paid_in_default_currency'
          ? this.paid_in_default_currency
          : this.model[this.ref_input_last_focus] || 0
      )
    },
    setValueCash(val) {
      if (val) {
        this.paid_in_default_currency = 0
        this.paid_in_to_currency = null
        this.clear()
      } else {
        this.paid_in_default_currency = null
        this.paid_in_to_currency = null
        this.clear()
      }
    },
    clear() {
      // UI REFACTOR: Simplified clear (keeps coupon as it's allowed with cash)
      this.model.discount_amount = null
      this.model.discount_rate = null
      this.model.bank_transfer = null
      this.model.bank_transfer_riel = 0
      // Note: paid_in_coupon is NOT cleared here as it can be used with cash
      this.calculate()
    },
    onChangeKeyBoard(input) {
      this.value_keyboard_input = input ? input : null
      // UI REFACTOR: Removed paid_in_to_currency (KHR input removed)
      if (this.ref_input_last_focus == 'paid_in_default_currency') {
        this.paid_in_default_currency = this.value_keyboard_input
        this.handleCashInput()
      } else {
        this.model[this.ref_input_last_focus] = this.value_keyboard_input
        this.calculate()
      }
      setTimeout(() => {
        if (this.$refs[this.ref_input_last_focus]) {
          this.$refs[this.ref_input_last_focus].focus()
        }
      }, 300)
    },
    pickupAmountDefulatCurrency() {
      // UI REFACTOR: Clear bank if active, then set exact amount
      if (this.isBankPaymentActive) {
        this.isActive = ''
        this.model.payment_method_id = 1 // Set to cash payment method
        this.clearBankPayment()
      }
      this.paid_in_default_currency = -this.change_in_default_currency
      // UI REFACTOR: paid_in_to_currency not used (KHR removed)
      this.paid_in_to_currency = 0
      this.calculate()
      this.$nextTick(() => {
        if (this.$refs.paid_in_default_currency) {
          this.$refs.paid_in_default_currency.focus()
          this.$refs.paid_in_default_currency.select()
        }
      })
    },
    // UI REFACTOR: pickupAmountToCurrency removed (KHR currency input removed from UI)
    fetchTableByInterval(attributes) {
      this.$store
        .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH TABLE',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => this.defaultCheckTable(this.model.table_id))
    },
    defaultCheckTable(table_id) {
      if (table_id) {
        this.autoSelectedTable(
          this.$store.state.restaurantSale.counterCheckout.tables
            .filter(t => t.table_id == table_id)
            .reduce((init, value) => (init = value), {})
        )
      }
    },
    autoSelectedTable(table) {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        table
      )
      if (!_.isEmpty(this.tableSelected)) {
        this.model.stock_out_id = this.tableSelected.stock_out_id
        this.model.table_id = this.tableSelected.table_id
      }
      this.calculate()
    },
    fetchResource() {
      this.loading = true
      this.paymentMethod()
        .then(response => {
          this.paymentMethods = response.data
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
      this.fetchBank()
      this.fetchRemarks()
    },
    fetchBank() {
      this.$emit('loading', true)
      this.bankProfile()
        .then(response => {
          this.bankProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    fetchRemarks() {
      this.$emit('loading', true)
      this.remarks()
        .then(response => {
          this.remarksOptions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    bankNameChange() {
      // UI REFACTOR: Simplified for single payment method (bank only)
      this.model.account_number = null
      this.model.account_name = null

      // UI REFACTOR: bank_transfer_riel set to 0 (KHR removed)
      this.model.bank_transfer_riel = 0

      if (this.accountOptions.length == 1) {
        this.model.account_name = this.accountOptions[0].name
        this.model.account_number = this.accountOptions[0].value
        this.focusInput()
      }
      this.calculate()
    },
    accountChange() {
      // UI REFACTOR: Simplified for single payment method (bank only)
      let account_name = this.accountOptions.find(
        el => el.value == this.model.account_number
      ).name
      this.model.account_name = account_name

      // UI REFACTOR: bank_transfer_riel set to 0 (KHR removed)
      this.model.bank_transfer_riel = 0
      this.focusInput()
      this.calculate()
    },
    focusInput() {
      // UI REFACTOR: Simplified for bank transfer only (USD only, KHR removed)
      if (this.isActive == 'bank_transfer') {
        // Transfer cash input to bank transfer (USD only)

        this.paid_in_default_currency = parseFloat(
          this.tableSelected.invoice_amount -
          this.tableSelected.total_pre_charge_amount
        )

        this.model.bank_transfer = this.model.paid_in_default_currency
        this.paid_in_default_currency = null
        // UI REFACTOR: paid_in_to_currency not used
        this.paid_in_to_currency = 0

        this.$nextTick(() => {
          if (this.$refs.bank_transfer_usd) {
            this.$refs.bank_transfer_usd.focus()
            this.$refs.bank_transfer_usd.select()
          }
        })
      }
      // UI REFACTOR: Removed cheque and credit card methods
    },
    async onPaymentMethodChange() {
      // UI REFACTOR: Simplified for bank transfer only (other methods removed)
      this.model.paid_in_default_currency = parseFloat(
        this.tableSelected.invoice_amount -
        this.tableSelected.total_pre_charge_amount
      )
      this.model.bank_transfer = this.model.paid_in_default_currency
      // UI REFACTOR: bank_transfer_riel set to 0 (KHR removed)
      this.model.bank_transfer_riel = 0

      // Clear cash input when switching to bank
      this.paid_in_default_currency = null
      this.paid_in_to_currency = 0

      // Reset bank account selection
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null

      this.calculate()
    }
  },
  watch: {
    isActive: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.is_city_ledger': function (val) {
      this.setValueCash(val)
    },
    'model.is_customer_ledger': function (val) {
      this.setValueCash(val)
    },
    'model.discount_type': function (val) {
      if (val) {
        this.calculate()
      }
    }
  }
}
</script>
<style scoped>
.invoice {
  padding: 0 20px 0 20px;
}

.invoice-header {
  padding: 1px;
}

.invoice .invoice-from {
  padding: 5px 20px;
}

.invoice .invoice-to {
  padding: 2px 20px;
}

.invoice .invoice-date {
  padding: 2px 20px;
}

.invoice>div:not(.invoice-footer) {
  margin-bottom: 10px;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  padding: 3px 5px;
}

.table-responsive {
  max-height: 15vh;
  overflow-x: scroll;
  overflow-y: scroll;
}

.table>thead>tr>th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}

.invoice .invoice-price .invoice-price-left {
  padding: 2px 10px;
  font-size: 15px;
}

.invoice .invoice-price .invoice-button {
  font-size: 23px;
  margin-left: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
}

.invoice .invoice-price .invoice-button .btn-default {
  height: 122px;
  background: #d6dce0;
  border-color: #d6dce0;
  border-radius: 0%;
}

.invoice .invoice-price .invoice-price-right {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
}

.widget-table-img {
  width: 100px;
  height: auto;
}

.payment-type {
  font-size: 2.5rem;
  margin: 0;
}

.payment-type>li.active a {
  color: #2d353c;
}

.payment-type>li a {
  color: #999;
}

.form-control-lg {
  background: #fffefe;
}

.payment {
  background: #f2f3f4;
  padding: 0 0 5px 5px;
}

.invoice-footer {
  padding-top: 0;
}

.btn-row .btn {
  padding: 25px 25px;
  font-size: 0.875rem;
  min-width: 250px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 10px;
}

#keyboard {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
